/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import React from 'react'
import { Box } from '@mui/material'

export const DiscountCardIcon = ({ size = 18, borderColor = '#ffffff', strokeColor = '#ffffff' }) => {
  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: size,
        height: size,
      }}
    >
      <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="1.25" y="2.25" width="13.5" height="11.5" rx="2.75" stroke={borderColor} strokeWidth="1.5" />
        <path d="M3.5 6H12.5" stroke={strokeColor} strokeWidth="1.5" strokeLinecap="round" />
        <path d="M3.5 9.5H7" stroke={strokeColor} strokeWidth="1.5" strokeLinecap="round" />
      </svg>
    </Box>
  )
}

